// removed by extract-text-webpack-plugin
module.exports = {"brandsSearchBar":"brandsSearchBar--1mBxG"};


/*****************
 ** WEBPACK FOOTER
 ** ./apps/homepage/components/BrandsSearchBar/brandsSearchBar.scss
 ** module id = 606
 ** module chunks = 2 17
 **/